import React from 'react';
import clsx from 'clsx';
import { AlertProps } from './types';
import { styles } from './styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faExclamationCircle,
  faExclamationTriangle,
  faCheckCircle,
  faTimes,
} from '@fortawesome/free-solid-svg-icons';
import { Button } from '../Button';

const iconMap = {
  error: faExclamationCircle,
  warning: faExclamationTriangle,
  success: faCheckCircle,
};

export const Alert: React.FC<AlertProps> = ({
  variant,
  children,
  className,
  onDismiss,
}) => {
  return (
    <div className={clsx(styles.base, styles.variants[variant], className)}>
      <FontAwesomeIcon icon={iconMap[variant]} className={styles.icon} />
      <div className={styles.content}>{children}</div>
      {onDismiss && (
        <Button
          variant="ghost"
          size="sm"
          onClick={onDismiss}
          aria-label="Dismiss"
          className={styles.dismissButton}
          icon={<FontAwesomeIcon icon={faTimes} />}
        />
      )}
    </div>
  );
};

export type { AlertProps, AlertVariant } from './types';
export default Alert;
